class UserMgr {
    static _inst = null;

    static get inst() {
        if (this._inst) {
            return this._inst;
        }
        this._inst = new UserMgr();
        return this._inst;
    }

    constructor() {}

    _userInfo = null;
    // 获取 token
    get userInfo() {
        if (this._userInfo) return this._userInfo;

        try {
            const userInfoData = localStorage.getItem("huashi_userInfo");
            if (!userInfoData) {
                this._userInfo = {};
                return this._userInfo;
            }

            const parsedUserInfo = JSON.parse(userInfoData);
            this._userInfo = {
                userid: Number(parsedUserInfo.userid),
                token: parsedUserInfo.token,
            };

            return this._userInfo;
        } catch (error) {
            console.error("解析 userInfo 失败:", error);
            this._userInfo = {};
            return this._userInfo;
        }
    }

    set userInfo(value) {
        if (!value) return;
        this._userInfo = {};
        this._userInfo.userid = +value.userid || 0;
        this._userInfo.token = value.token || "";
        localStorage.setItem("huashi_userInfo", JSON.stringify(value));
    }
}

export default UserMgr;
